function hasQueryParams(locationHash) {
	return locationHash.indexOf('?') !== -1;
}

function getUserIdParam(locationHash) {
	return parseInt(locationHash.split('?')[1].replace('userId=', ''));
}

function getUserId(locationHash) {
	return hasQueryParams(locationHash) ? getUserIdParam(locationHash) : 0;
}

const userId = getUserId(window.location.hash);
const userIdSession = parseInt(window.sessionStorage.getItem('Schoolastic/Portal/User'));

if (!userIdSession && userId) {
	window.sessionStorage.setItem('Schoolastic/Portal/User', userId);
} else if (userIdSession && userId && (userId !== userIdSession)) {
	window.sessionStorage.setItem('Schoolastic/Portal/User', userId);
} else {

	if (!userId && !userIdSession) {

		window.parent.postMessage({
			schoolastic: {
				logoff: true
			}
		}, '*');

	}

}

export default {
	user: {
		id: parseInt(window.sessionStorage.getItem('Schoolastic/Portal/User')),
		language: 'pt_BR',
		name: null,
		email: null,
		profile: null,
		photo: null
	},
	school: {
		id: null,
		name: null
	}
};



// WEBPACK FOOTER //
// ./sources/domains/logged/state.js